import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

import StockSectionsGrid from "./StockSectionsGrid";

const StockMainSection = () => {
  const navigate = useNavigate();

  const handleAreaClick = (area) => {
    if (area?.to) navigate(area.to);
  };

  return (
    <Stack sx={{ flex: 1, width: "100%", minWidth: 0 }}>
      <Stack spacing={2} sx={{ flex: 1, width: "100%", minWidth: 0 }}>
        <StockSectionsGrid onAreaClick={handleAreaClick} />
      </Stack>
    </Stack>
  );
};

export default StockMainSection;
